export const LOTTABLE_FIELDS = [
    {
        'label':'lottable03Label',
        'elementId':'lottable03',
        'name':'Lottable03',
        'nameLabel':'Lottable03Label',
        'receiptField':'receiptLineLottable03'
    },
    {
        'label':'lottable06Label',
        'elementId':'lottable06',
        'name':'Lottable06',
        'nameLabel':'Lottable06Label',
        'receiptField':'receiptLineLottable06'
    },
    {
        'label':'lottable07Label',
        'elementId':'lottable07',
        'name':'Lottable07',
        'nameLabel':'Lottable07Label',
        'receiptField':'receiptLineLottable07'
    },
    {
        'label':'lottable09Label',
        'elementId':'lottable09',
        'name':'Lottable09',
        'nameLabel':'Lottable09Label',
        'receiptField':'receiptLineLottable09'
    }
]
export const TRANSFER_CONSTANTS = {
    STORER_KEY: 'storer_key',
};


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/lottable-fields.constants.ts